import React from "react";
import { DataTable } from "react-native-paper";
import { formatDateTimeNoYear } from "../../utils/utils";
import { TableValueCellComponent } from "./Types";

export const TableDateCell: TableValueCellComponent = ({ value }) => {
  return (
    <DataTable.Cell>
      {value ? value.toDate().toLocaleString("ru-RU").split(",")[0] : "Error"}
    </DataTable.Cell>
  );
};

export const TableDateTimeCell: TableValueCellComponent = ({ value }) => {
  return (
    <DataTable.Cell>
      {value ? value.toDate().toLocaleString("ru-RU") : ""}
    </DataTable.Cell>
  );
};

export const TableDateTimeNoYearCell: TableValueCellComponent = ({ value }) => {
  return (
    <DataTable.Cell>
      {value ? formatDateTimeNoYear(value) : "Error"}
    </DataTable.Cell>
  );
};
